import firebase from "firebase/app";

import { auth, firestore } from "./firebase";

const provider = new firebase.auth.GoogleAuthProvider();

export const signInWithGoogle = () => {
  return auth.signInWithPopup(provider);
};

const FacebookProvider = new firebase.auth.FacebookAuthProvider();

export const signInWithFacebook = () => {
  auth.signInWithPopup(FacebookProvider);
};

export const generateUserDocument = async (user, additionalData) => {
  if (!user) return;
  const userRef = firestore.doc(`users/${user.uid}`);
  const snapshot = await userRef.get();
  if (!snapshot.exists) {
    const { email, displayName, companyName = "Company" } = user;
    try {
      await userRef.set({ displayName, email, companyName, ...additionalData });
    } catch (e) {
      console.log(e);
    }
  }
  return getUserDocument(user.uid);
};

const getUserDocument = async (uid) => {
  if (!uid) return null;
  try {
    const userDocument = await firestore.doc(`users/${uid}`).get();
    return { uid, ...userDocument.data() };
  } catch (e) {
    console.log(e);
  }
};

export const createUser = async (userObject) => {
  const { email, password } = userObject;
  const { user } = await auth.createUserWithEmailAndPassword(email, password);
  generateUserDocument(user, userObject);
};

export const logInUser = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);

export const logOutUser = () => auth.signOut();
